import { render, staticRenderFns } from "./AddCollectioned.vue?vue&type=template&id=7672f888&scoped=true&"
import script from "./AddCollectioned.vue?vue&type=script&lang=js&"
export * from "./AddCollectioned.vue?vue&type=script&lang=js&"
import style0 from "./AddCollectioned.vue?vue&type=style&index=0&id=7672f888&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7672f888",
  null
  
)

export default component.exports